import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo.png'
import HowItWorks from '../../components/HowItWorks';

const ProcessPage = () => {
    return(
        <Fragment>
            <Navbar Logo={Logo}/>
            <HowItWorks />
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ProcessPage;
